import React from "react";
import { FieldProps } from "@rjsf/utils";
import { UserInput } from "../../../../../../Submissions/Fields";
import BaseFieldPreview from "./BaseFieldPreview";

const UserFieldPreview = (props: FieldProps) => {
  const widgetPreview = <UserInput {...props} />;
  return <BaseFieldPreview widgetPreview={widgetPreview} {...props} />;
};

export default UserFieldPreview;
